import { useEffect } from "react";

export function GlobalSyncAnimator() {
  useEffect(() => {
    const ANIMATION_MS = 800;

    const handleClick = (e: MouseEvent) => {
      const target = e.target as Element | null;
      if (!target) return;

      const button = target.closest('button, [role="button"]') as HTMLElement | null;
      if (!button) return;
      if (button.hasAttribute("disabled")) return;

      const icon =
        (button.querySelector('[class*="lucide-refresh"]') as SVGElement | null) ||
        (button.querySelector('[class*="lucide-rotate"]') as SVGElement | null) ||
        (button.dataset.sync !== undefined
          ? (button.querySelector("svg") as SVGElement | null)
          : null);

      if (!icon) return;
      if (icon.classList.contains("animate-spin")) return;
      if (icon.classList.contains("sync-icon-clicked")) return;

      icon.classList.add("sync-icon-clicked");
      button.classList.add("sync-button-clicked");

      window.setTimeout(() => {
        icon.classList.remove("sync-icon-clicked");
        button.classList.remove("sync-button-clicked");
      }, ANIMATION_MS);
    };

    document.addEventListener("click", handleClick, { capture: true });
    return () => {
      document.removeEventListener("click", handleClick, { capture: true } as EventListenerOptions);
    };
  }, []);

  return null;
}
